export const thresholdKeys = ['danger', 'alert', 'highwarning', 'warning', 'ok', 'excessive', 'noData']
